import { render } from "./Zipper.vue?vue&type=template&id=14a4b6d8&scoped=true"
import script from "./Zipper.vue?vue&type=script&lang=js"
export * from "./Zipper.vue?vue&type=script&lang=js"

import "./Zipper.vue?vue&type=style&index=0&id=14a4b6d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14a4b6d8"

export default script